// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Venezuela from '../_raw/flag/icon_flag_venezuela.png';

export default () => <img src={Venezuela} alt="Venezuela" />;
